<template>
  <div class="print" ref="print">
    <div class="card" ref="printcard" id="card">
      <div class="top-panel">
        <div class="top-content">
          <div class="top-content-head">
            <img src="@/assets/imgs/logoblack.png" />
            <span class="top-content-head-title">天津费加罗电子有限公司</span>
            <div class="top-content-head-tip">一 智能报警终端 一</div>
          </div>
          <div class="top-content-desc">
            <div class="top-content-desc-left">
              <!-- <span>产品型号：{{collector.name ? collector.name : '-'}}</span>
                            <span>工作电压：{{collector.type === 0 ? 'DC 24V' : 'DC 7V'}}</span>
                            <span>生产日期：{{collector.mfd ? collector.mfd : '-'}}</span>
              <span>MADE IN CHINA</span>-->
              <img src="@/assets/imgs/wxcode.png" />
            </div>
            <div class="top-content-desc-right">
              <!-- <span>微信扫二维码连接设备</span>
              <img src="@/assets/imgs/wxcode.png" />-->
              <!-- <span class="bottom-panel-title">IMEI:</span> -->

              <div class="imei">
                <span>IMEI:</span>
                <div class="content-imei">
                  <span v-for="(item, index) in list" :key="index">{{item}}</span>
                </div>
              </div>
              <img id="barcode" />
            </div>
          </div>
          <div class="tips">
            <span>1.微信扫码打开小程序</span>
            <span>2.点击"添加设备"扫条码进行绑定</span>
          </div>
        </div>
      </div>
      <!-- <div class="bottom-panel">
        <span class="bottom-panel-title">IMEI:</span>
        <div class="bottom-content">
          <img id="barcode" />
          <div class="bottom-content-imei">
            <span v-for="(item, index) in list" :key="index">{{item}}</span>
          </div>
        </div>
      </div>-->
      <button v-show="false" ref="btnprint" v-print="printObj">打印</button>
    </div>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";
export default {
  name: "print",
  props: {
    collector: {
      type: Object,
    },
  },
  data() {
    return {
      printObj: {
        id: "card",
        //   popTitle: false,
        //   extraCss: 'https://www.google.com,https://www.google.com',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      imei: "123452345678906",
      list: [],
    };
  },
  mounted() {
    let width = window.screen.width;
    // this.$refs.card.style.width = width + 'px'
    // this.$refs.print.style.height = width * 0.59  + 'px'
    // this.$refs.printcard.style.height = width * 0.59  + 'px'
    console.log(width);
  },
  methods: {
    JsBarcode,
    printclick() {
      this.list = this.collector.imeiList;
      JsBarcode("#barcode")
        .options({ font: "OCR-B", width: 1, height: 100, displayValue: false }) // Will affect all barcodes
        .CODE128(this.collector.imei, { fontSize: 12, textMargin: 5 })
        .render();
      this.$refs.btnprint.click();
    },
  },
};
</script>

<style lang="less" scoped>
// @import '../../../utils/utils.less';
.card {
  display: none;
}

@media print {
  .card {
    // background-color: #D7D6D5;
    position: fixed;
    top: 0;
    left: 2%;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    border-radius: 10px;
    padding: 3% 5% 3% 5%;
    font-weight: 700;
    font-family: "Microsoft YaHei";
    // font-family: 'STZhongsong';
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // font-size: 68px;
    .top-panel {
      height: 70%;
      display: flex;
      & img {
        width: 150px;
        height: 150px;
        padding: 5px;
        margin-top: 5px;
      }
      .top-content {
        flex: 1;
        // padding-left: 55px;
        display: flex;
        flex-direction: column;
        .top-content-head {
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .top-content-head-title {
            font-size: 76px;
            width: 55%;
          }
          .top-content-head-tip {
            font-size: 68px;
            flex: 1;
            text-align: center;
          }
        }
        .top-content-desc {
          flex: 1;
          display: flex;
          .top-content-desc-left {
            width: 35%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            & span {
              font-size: 60px;
            }
            & img {
              margin-left: 100px;
              width: 420px;
              height: 420px;
            }
          }
          .top-content-desc-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            & img {
              margin-top: -30px;
              width: 100%;
              height: 340px;
            }
          }
        }
      }
    }
    .content-imei {
      width: 100%;
      // padding: 0 90px 0 20px;
      display: flex;
      justify-content: space-between;
      // z-index: 99;
      font-family: Arial, Helvetica, sans-serif;
    }
    .imei {
      font-size: 86px;
      width: 88%;
      display: flex;
      justify-items: center;
    }
    .tips {
      font-size: 66px;
      display: flex;
      justify-content: space-around;
      padding-right: 50px;
    //   margin-left: -80px;
    }
    /*  .bottom-panel {
      flex: 1;
      display: flex;
      margin-bottom: -5%;
      .bottom-panel-title {
        width: 180px;
        // height: 300px;
        // line-height: 280px;
        height: 70%;
        display: flex;
        align-items: center;
        z-index: 99;
      }
    } */
  }
}
</style>


// WEBPACK FOOTER //
// src/views/business/collector/CollectorPrint.vue